import { useEffect, useState } from "react";
import { ShowImage, haveValue } from "../../utils/helpers";
import moment from "moment";

const NotificationCard = (props) => {
  const { event } = props;
  const [eventData, setEventData] = useState({
    type: "",
    date: "",
  });
  useEffect(() => {
    if (haveValue(event.dobFormatted) && event.is_birthday) {
      console.log(event.dobFormatted, "event.dobFormatted");
      setEventData({
        type: "Birthday Celebration",
        date: moment(event.dobFormatted).format("MMM D, YYYY"),
      });
    } else if (haveValue(event.anniversaryMonthDay) && event.is_anniversary) {
      console.log(event.anniversaryFormatted, "event.anniversaryFormatted");
      setEventData({
        type: "Anniversary Celebration",
        date: moment(event.anniversaryFormatted).format("MMM D, YYYY"),
      });
    }
  }, [event]);

  console.log(eventData, "check eventData here");

  const AnniversaryImage = () => (
          <svg width="38" height="38" className="celebration-icon" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="19" cy="19" r="19" fill="#E31B54" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.9311 9.82764C23.1718 9.82767 23.4042 9.91604 23.5841 10.076C23.7639 10.2359 23.8789 10.4564 23.907 10.6954L23.9139 10.8104V11.7932H25.8794C26.3753 11.793 26.8529 11.9803 27.2165 12.3175C27.5801 12.6546 27.8028 13.1168 27.84 13.6113L27.8449 13.7587V25.5518C27.8451 26.0477 27.6578 26.5253 27.3206 26.8889C26.9835 27.2525 26.5213 27.4752 26.0268 27.5124L25.8794 27.5173H12.1208C11.6249 27.5174 11.1473 27.3302 10.7837 26.993C10.4201 26.6558 10.1974 26.1937 10.1602 25.6992L10.1553 25.5518V13.7587C10.1551 13.2628 10.3424 12.7852 10.6796 12.4216C11.0167 12.058 11.4789 11.8353 11.9734 11.7981L12.1208 11.7932H14.0863V10.8104C14.0866 10.5599 14.1825 10.319 14.3545 10.1368C14.5264 9.9547 14.7614 9.8451 15.0115 9.83042C15.2615 9.81574 15.5077 9.89709 15.6998 10.0579C15.8919 10.2186 16.0154 10.4467 16.0449 10.6954L16.0518 10.8104V11.7932H21.9484V10.8104C21.9484 10.5498 22.0519 10.2998 22.2362 10.1155C22.4205 9.93118 22.6705 9.82764 22.9311 9.82764ZM25.8794 13.7587H12.1208V25.5518H25.8794V13.7587ZM22.1115 15.6023C23.2043 16.2392 23.9453 17.5108 23.9129 18.9653C23.8726 20.7697 22.5272 22.2517 20.5342 23.486L20.2924 23.6324C19.8964 23.8683 19.4767 24.1317 19.0001 24.1317C18.6424 24.1317 18.3171 23.9843 18.0095 23.8093L17.7078 23.6324C15.5821 22.3696 14.1295 20.8414 14.0873 18.9653C14.0549 17.5108 14.7959 16.2392 15.8887 15.6023C16.8262 15.0559 17.9869 15.0058 19.0001 15.6387C20.0123 15.0058 21.174 15.0559 22.1115 15.6023ZM21.1219 17.3005C20.7494 17.0843 20.3062 17.0588 19.8659 17.4342L19.7568 17.5374C19.572 17.7238 19.3248 17.8355 19.0628 17.8509C18.8007 17.8663 18.5421 17.7844 18.3367 17.6209L18.2434 17.5374C17.7677 17.0558 17.2813 17.0657 16.8783 17.3015C16.4253 17.5649 16.0351 18.1565 16.0528 18.9211C16.0695 19.6877 16.6602 20.6704 18.4783 21.8006L18.7122 21.9421C18.8075 21.9991 18.9028 22.0571 19.0001 22.1111L19.1446 22.0276L19.288 21.9421C21.2889 20.753 21.9297 19.7191 21.9474 18.9211C21.9651 18.1565 21.5749 17.5649 21.1219 17.3005Z"
      fill="white"
    />
  </svg>
    )

  return (
    <>
      <div className="d-flex connection-card-div">
        <div className="position-relative">
          <img
            className="notification-profile-pic"
            src={ShowImage(
              event.connectionDetails?.profilePhoto,
              event.connectionDetails?.fullName
            )}
            alt="img"
          />
          {eventData.type === "Birthday Celebration" ? <img
            className="celebration-icon"
            src={`/images/BirthdayPink.svg`}
          />:<AnniversaryImage/>}
         
        </div>
        <div className="w-100 notification-info">
          <h5 className="text-start">
            {event.connectionDetails?.fullName}'s {eventData.type}
          </h5>
          <p>{eventData.date}</p>
        </div>
      </div>
    </>
  );
};

export default NotificationCard;
